import {html, css, LitElement} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';

import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import {query} from 'lit/decorators/query.js';

import store from '../../store';

import search from '../../../icons/search';
import place from '../../../icons/place';

@customElement('location-select')
export class LocationSelect extends connect(store)(LitElement) {
	@query('#addressinput')
	addressInput;

	@property()
	address = '';

	@property({type: Function})
	selectedLocation = null;

	@property({type: Function})
	isSatisfied = null;

	@property({type: Function})
	action = null;

	@property({type: Function})
	geolocateAction = null;

	@property({type: Boolean})
	geolocationAllowed = true;

	static styles = [
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}

			.inputs {
				display: flex;
				flex-direction: row;
			}

			.border {
				border: 0 none;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}

			input {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				min-height: var(--height-widget);
				transition: background-color 0.4s, color 0.4s;
				padding: 0 1em;
				line-height: 120%;
				margin: 0;
				width: 100%;
				box-sizing: border-box;
				text-align: left;
			}

			button {
				background-color: transparent;
				cursor: pointer;
				min-width: var(--height-widget);
			}

			.location {
				padding: 0.5rem;
				font-family: var(--font-family-light);
				color: var(--color-text-widget);
				font-size: 12px;
				opacity: 0.7;
			}

			.notSatisfied {
				border-left-color: var(--color-warn);
			}

			@media (max-width: 768px) {
				input {
					width: 50vw;
				}
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.location = state.solar?.data?.project?.location ?? state.lightProfile?.data?.project?.location ?? null;
	}

	setAddress() {
		if (this.action) {
			store.dispatch(this.action(
				{
					address: this.addressInput.value
				}
			));
		}
	}

	geolocate() {
		if (this.geolocateAction) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					const latlng = position.coords.latitude + ',' + position.coords.longitude;

					store.dispatch(this.geolocateAction({
						latlng: latlng,
					}));
				}, (error) => {
					this.geolocationAllowed = false;

					if (error.code === 1) {
						// User denied Geolocation
					} else if (error.code === 2) {
						// Location Unavailable
					} else if (error.code === 3) {
						// Time out reached
					}
				});
			} else {
				// Browser doesn't support Geolocation
				this.geolocationAllowed = false;
			}
		}
	}

	render() {
		const s = store.getState();
		return html`
			<div>
				<div class="title">${msg('Location')}</div>
				<div class="inputs ${classMap({notSatisfied: !this.isSatisfied(s)})}">
					<input id="addressinput" class="border" value="${this.selectedLocation(s) !== null ? this.selectedLocation(s).name : ''}"
						   @change=${this.setAddress}>
					<button @click=${this.setAddress} class="border submit">${search}</button>

					${when(this.geolocationAllowed, () => html`
						<button @click=${this.geolocate} class="border geolocate">${place}</button>
					`)}

				</div>
				${when(this.isSatisfied(s), () => html`
					<div class="location">
						${when(this.location, () => html`
							${this.location?.name} (${msg('Latitude')}: ${this.location?.latitude}, ${msg('Longitude')}: ${this.location?.longitude})`)
						}
					</div>
				`, () => html`
					<div class="location">
						${msg('Choose location of project')}
					</div>
				`)}

			</div>

		`;
	}
}
